/*
 * COPYRIGHT (c) 2023
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { Button, Checkbox, FileDrop, Icon, Modal } from '@scuf/common';
import React, { useContext, useEffect, useState } from 'react';
import descriptors from '../../locales/en-US/descriptors';
import { useTranslation } from '@scuf/localization';
import './AddUtilityBillComponentTheme.scss';
import { ApiContext } from '../../context/ApiContext';
import { IAny } from '../DashboardKPIWidgets/IEnergyManagementProps';
import moment from 'moment';
import ProgressTab from '../UtilityServiceModal/ProgressTab/ProgressTab';
import ProgressTabManageBill from '../UtilityServiceModal/ProgressTab/ProgressTabManageBill';
import { Notification } from '@scuf/common';

interface AddUtilityBillComponentProps {
  onFileUpload: (base64Data: string) => void;
  isNewBill: boolean;
  utilityCellData: IAny;
  billDetails: IAny;
  setPdfError: IAny;
  setPDFResponse: IAny;
  setHasFieldChanged: (hasFieldChanged: boolean) => void;
  setEntryFromPDF: (entryFromPDF: boolean) => void;
  setEntryTablePDF: (entryTablePDF: boolean) => void;
  setIsUpdateTable: (isUpdateTable: boolean) => void;
  setTriggerNewBill: (triggerNewBill: boolean) => void;
  enableEditBill: boolean;
  setIsPDFExtracted: (a: boolean) => void;
  setEditBill: (a: boolean) => void;
  setIsNewBill: (a: boolean) => void;
  isPDFExtracted: boolean;
  onBillSave: () => void;
  addNewBill: () => void;
  setBillDetails: IAny;
  setIsDisplayTable: IAny;
  setIsMultipleUploaded: (a: boolean) => void;
}

const AddUtilityBillComponentSingleUpload: React.FC<AddUtilityBillComponentProps> = ({
  onFileUpload,
  isNewBill,
  utilityCellData,
  billDetails,
  setPdfError,
  setPDFResponse,
  setHasFieldChanged,
  setEntryFromPDF,
  setEntryTablePDF,
  setIsUpdateTable,
  setTriggerNewBill,
  enableEditBill,
  setIsPDFExtracted,
  setEditBill,
  setIsNewBill,
  isPDFExtracted,
  onBillSave,
  addNewBill,
  setIsMultipleUploaded
}) => {
  const d = descriptors.UtilityBuilder;
  const [t] = useTranslation();
  const [uploadedFile, setUploadedFile] = useState<IAny>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [fileNameError, setFileNameError] = useState<boolean>(false);
  const [checkSpace, setCheckSpace] = useState<boolean>(false);
  const apiContext = useContext(ApiContext);
  const [isProgressTab, setIsProgressTab] = useState<boolean>(false);
  const [enableAutoExtraction, setEnableAutoExtraction] = useState<boolean>(
    false
  );

  const [refreshFileDrop, setRefreshFileDrop] = useState<boolean>(false);
  const [random, setRandom] = useState<number>(1);

  const toggleComponent = () => {
    setIsModalOpen(true);
  };
  const handlePDFDownload = () => {
    const pdfData = {
      logicalAccountId: billDetails.logicalAccountId,
      accountId: billDetails.accountId,
      fileName: billDetails.billFileName || ''
    };
    apiContext.manageBillPdfDownload(pdfData);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const maxFileSize = 5000000;

  const handleInitialFileUpload = (file: File[]) => {
    console.log('hereeee', file);
    const tempuploadedFile: IAny = file;
    // if(file.length > 1) {
    //   tempuploadedFile.concat(file);
    // }else {
    //   tempuploadedFile.push(file[0]);
    // }
    console.log('tempuploadedFile dsfsdfsdfserwer', tempuploadedFile);
    setUploadedFile(tempuploadedFile);
    setRandom(Math.random());
    setIsModalOpen(true);
  };

  const handleFileUpload = async (file: File[]) => {
    setHasFieldChanged(true);
    const tempuploadedFile: IAny = uploadedFile;
    const pdfRegex = new RegExp(/[`@!#$%^&*()+\=\[\]{};':"\\|<>\/?~]/, 'g');
    const spaceregex = new RegExp(/\s/, 'g');
    // if (pdfRegex.test(uploadedFile.name.split('.pdf')[0])) {
    //   setCheckSpace(false);
    //   setFileNameError(true);
    //   setPdfError(true);
    // } else {
    //   setCheckSpace(false);
    //   setPdfError(false);
    //   setFileNameError(false);
    // }

    // setUploadedFile([uploadedFile]);
    console.log('error message', errorMessage);
    if (errorMessage === '') {
      console.log('tempuploadedFile ****', tempuploadedFile);
      const reader = new FileReader();
      //reader.readAsDataURL(tempuploadedFile);
      if (apiContext.ocrManageBill && !enableEditBill && isNewBill) {
        setIsProgressTab(true);
        setEntryTablePDF(true);
        setIsUpdateTable(false);
        const res = await apiContext.getParamsFromPDFForMultipleUpload(
          tempuploadedFile
        );
        console.log('response is successful', res);
        setIsMultipleUploaded(true);
        // setPDFResponse(res, uploadedFile);
        // setIsUpdateTable(true);
        // setEntryFromPDF(true);
        // onFileUpload(uploadedFile);
        // setIsMultipleUploaded(true);
        setTimeout(() => {
          handleModalClosure();
        }, 1000);
      } else {
        onFileUpload(uploadedFile);
        closeModal();
      }

      if (!apiContext.ocrManageBill || enableEditBill) {
      }
      // closeModal();
    }
  };
  const handleRemoveFile = () => {
    setUploadedFile(null);
    onFileUpload('');
    setPdfError(false);

    if (isPDFExtracted) {
      setIsPDFExtracted(false);
      setEditBill(false);

      setTimeout(() => addNewBill(), 2000);

      // setBillDetails({})
    }
  };

  const handleModalClosure = () => {
    // onFileUpload(uploadedFile);
    setIsProgressTab(false);
    closeModal();
  };

  useEffect(() => {
    if (refreshFileDrop) {
      setRefreshFileDrop(false);
    }
  }, [refreshFileDrop]);

  const dateFormat = (dateString: IAny) => {
    const dateParts = moment(dateString, 'YYYY-MM-DD').format('MMM, YYYY');

    return dateParts;
  };

  console.log('uploadedFile', uploadedFile);
  return (
    <div>
      <div className="utility-bill-header">
        {uploadedFile &&
          uploadedFile.map((file: IAny, index: IAny) => (
            <div key={index} className="uploaded-file-container">
              <span>
                <Icon name="document" size="small" />
                <span>
                  {/* Utility Bill */}
                  {billDetails &&
                    billDetails.uploadedBill &&
                    billDetails.uploadedBill.name &&
                    billDetails.uploadedBill.name.split('.')[0]}
                  {/* {t(d.Utilitybill)} */}
                  <span style={{ marginLeft: '3px' }}>
                    {billDetails.endDate &&
                      ' ' + billDetails &&
                      dateFormat(billDetails.endDate)}
                    .pdf
                    {checkSpace ? (
                      <span className="total-error pdf-upload-error">
                        Filename contains Space(s).
                      </span>
                    ) : fileNameError ? (
                      <span className="total-error pdf-upload-error">
                        Filename contains Special Character(s).
                      </span>
                    ) : (
                      ''
                    )}
                  </span>
                </span>
              </span>
              <Button
                className="remove-button"
                type="link"
                content="Remove"
                onClick={handleRemoveFile}
              />
            </div>
          ))}
        {uploadedFile ? (
          ''
        ) : // <Button
        //   className="remove-button"
        //   type="link"
        //   content="Remove"
        //   onClick={handleRemoveFile}
        // />
        isNewBill || !billDetails.isBillUploaded ? (
          <div style={{ width: '100%' }}>
            {/* {apiContext.ocrManageBill && isNewBill && (
              <Checkbox
                label="Enable Auto Extraction Of Utility Bill"
                checked={enableAutoExtraction}
                onChange={(checked) => {
                  setEnableAutoExtraction(checked);
                }}
              />
            )} */}
            {!enableEditBill && isNewBill && (
              <Notification
                className="savings-notification"
                hasIcon={true}
                severity="information"
                title="Automatic Extraction of utility data from Utility Bill PDF"
              >
                {
                  "Uploading a PDF of your Utility Bill enables auto-filling of data by our Intelligent Document Reader using 'Optical Character Recognition'"
                }
              </Notification>
            )}
            {uploadedFile && (
              <span
                className="UploadElectricityBill-header"
                onClick={toggleComponent}
              >
                <Icon
                  className="Upload-Electricity-Bill-icon"
                  root="common"
                  name="cloud-upload"
                  size="small"
                />
                {t(d.UPLOADBILL, {
                  utilityType: utilityCellData.utilityType
                })}
                {/* need to check why the above one is not working. For temporary given the below. */}
                {/* {`Upload ${utilityCellData.utilityType} Bill`} */}
              </span>
            )}
          </div>
        ) : (
          billDetails.isBillUploaded && (
            <>
              <span>{}</span>
              <Icon
                className="DownloadButton-icon"
                root="common"
                name="cloud-download"
                size="small"
                onClick={handlePDFDownload}
              />
              {/* <span>{billDetails && dateFormat(billDetails.endDate)}</span> */}
              <Button
                className="remove-button"
                type="link"
                content="Download Bill"
                onClick={handlePDFDownload}
              />
            </>
          )
        )}
      </div>
      <React.Fragment>
        <div
          // open={isModalOpen}
          // closeIcon={true}
          // onClose={() => setIsModalOpen(false)}
          // size="large"
          className="utility-bill-modal-container"
        >
          <div
            className={
              isProgressTab
                ? 'upload-utility-bill-modal-content pdf-upload-progress'
                : 'upload-utility-bill-modal-content'
            }
          >
            {!refreshFileDrop && !billDetails.isBillUploaded && (
              <FileDrop
                className="utility-bill-file-drop-section"
                acceptedTypes={'.pdf'}
                onAccepted={handleInitialFileUpload}
                maxSize={maxFileSize}
                multiple={true}
              />
            )}

            <Modal
              open={isModalOpen}
              closeIcon={true}
              onClose={() => {
                handleRemoveFile();
                setRefreshFileDrop(true);
                setIsModalOpen(false);
              }}
              size="large"
              className="utility-bill-upload-new-modal"
            >
              <Modal.Header>
                <>Intelligent Document Reader</>
              </Modal.Header>
              <Modal.Content className="utility-multiple-upload-modal-content">
                {isProgressTab ? (
                  <ProgressTabManageBill
                    ocrManageBill={apiContext.ocrManageBill}
                    closeModal={() => {
                      onFileUpload(uploadedFile[0]);
                      setIsProgressTab(false);
                      closeModal();
                    }}
                  />
                ) : (
                  [
                    <div className="utility-bill-modal-subheader">
                      <div className="detail">
                        <span className="label">Account Number</span>
                        <span className="value">
                          {utilityCellData && utilityCellData.accountNumber}
                        </span>
                      </div>
                      <div className="detail">
                        <span className="label">Utility Type</span>
                        <span className="value">
                          {utilityCellData && utilityCellData.utilityType}
                        </span>
                      </div>
                      <div className="detail">
                        <span className="label">Billing Cycle</span>
                        <span className="value">
                          <span className="billing-cycle">
                            <span>{billDetails && billDetails.startDate}</span>
                            {billDetails &&
                              billDetails.startDate &&
                              billDetails.endDate &&
                              ' to'}
                            <span>{billDetails && billDetails.endDate}</span>
                          </span>
                        </span>
                      </div>
                    </div>,

                    <div className="pdf-upload-message">
                      Please upload a PDF file of the utility bill
                    </div>,
                    <FileDrop
                      className="utility-bill-file-drop-section"
                      acceptedTypes={'.pdf'}
                      onAccepted={handleInitialFileUpload}
                      maxSize={maxFileSize}
                      multiple={false}
                      disabled={true}
                    />,

                    // {
                    <div className="utility-multiple-upload-container">
                      {random &&
                        uploadedFile &&
                        uploadedFile.length &&
                        uploadedFile.map((file: IAny, index: IAny) => {
                          return (
                            <div className="utility-bill-multiple-file-upload">
                              {/* <Icon
                                                name={'intl-trip'}
                                                size='large'
                                              /> */}
                              <>{file.name}</>
                              {/* <Button
                                className="remove-button"
                                type="link"
                                content="Remove"
                                onClick={() => {
                                  handleRemoveFile();
                                  setRefreshFileDrop(true);
                                  setIsModalOpen(false);
                                }}
                              /> */}
                            </div>
                          );
                        })}
                    </div>

                    // }
                  ]
                )}
                <Modal.Footer>
                  {!isProgressTab && (
                    <Button
                      content="Submit"
                      className="utility-bill-multiple-upload-submit"
                      onClick={() => handleFileUpload(uploadedFile)}
                    />
                  )}
                </Modal.Footer>
              </Modal.Content>
            </Modal>
          </div>
        </div>
      </React.Fragment>
    </div>
  );
};

export default AddUtilityBillComponentSingleUpload;
